<div class="page-header-bar">
  <div class="content85percent">
    <div class="float-start">
      @if (!supportContext.isActive) {
        <h1>My Account</h1>
      } @else {
        <div>
          <button type="button" class="btn-secondary back-btn" (click)="returnToSupportPage()">
            <i class="fa-solid fa-arrow-left"></i> Back to Manage Users
          </button>
          <span class="ms-3">
            <i class="fa-solid fa-user-gear"></i> Managing commissions for: <strong>{{ supportContext.userEmail }}</strong>
          </span>
        </div>
      }
    </div>
  </div>
</div>
<div class="content85percent">
  <div class="row">
    <div class="col-12">
      <router-outlet #routerOutlet="outlet"></router-outlet>
    </div>
  </div>
</div>
